export default __webpack_public_path__ + "static/media/platform_event_notifications.32e7775a.svg";